<template>
  <div class="restructureEditor">
    <el-upload
      :class="myRef + 'upload'"
      :action="serverUrl"
      name="file"
      :headers="headers"
      :show-file-list="false"
      list-type="picture"
      accept=".jpg,.png,.jpeg"
      with-credentials
      :multiple="true"
      style="height: 0px; display: none;"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
    </el-upload>
    <quill-editor
      class="ql-editor"
      v-model="content"
      :ref="myRef"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      :class="{jyxClass: jyxStyle}"
    >
    </quill-editor>
  </div>
</template>
<script>
/**
 *       新富文本编辑器。
 *      create by wjl at 2021.8.2
 *      把工具栏分离，用自定义方法进行控制方式
 *
 */
// import hljs from 'highlight.js'
import bus from "@/vendor/eventbus";
// import 'highlight.js/styles/github-dark.css'
import { quillEditor, Quill } from "vue-quill-editor";
// 自定义图片上传
import ImageResize from "quill-image-resize-module";

Quill.register("modules/imageResize", ImageResize);
// 自定义字体大小
let fontSizeStyle = Quill.import("attributors/style/size");
fontSizeStyle.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "28px",
  "32px",
];
Quill.register(fontSizeStyle, true);
// 自定义行高
let Parchment = Quill.import("parchment");

class lineHeightAttributor extends Parchment.Attributor.Style {}

const lineHeightStyle = new lineHeightAttributor("lineHeight", "line-height", {
  scope: Parchment.Scope.INLINE,
  whitelist: ["initial", "1", "1.5", "2", "3", "4", "5"],
});

Quill.register({ "formats/lineHeight": lineHeightStyle }, true);

export default {
  name: "zl-editor",
  props: {
    /*编辑器的内容*/
    value: {
      type: String,
    },
    myRef: {
      type: String,
      default: "zlEditor",
    },
    maxHeight: {
      // 编辑区域最大高度
      type: String,
      default: "", // '100px'  || '100%'
    },
    minHeight: {
      // 编辑区域最小高度
      type: String,
      default: "", // '100px'  || '100%'
    },
    height: {
      // 确定编辑区域高度
      type: String,
      default: "", // '100px'  || '100%'
    },
    jyxStyle: {
      // 定制样式 课程3156
      type: Boolean,
      default: false,
    },
  },

  components: {
    quillEditor,
  },
  data() {
    return {
      content: this.value,
      serverUrl: `${process.env.UPLOAD_NAME}/file/uploadImage`, // 这里写你要上传的图片服务器地址
      editorOption: {
        theme: "snow", // or 'bubble'
        placeholder: "请输入内容",
        modules: {
          imageResize: {
            modules: ["Resize", "DisplaySize"],
          }, // 图片调整大小的关键这在这里可以 其他的参数因人而异，
          clipboard: {
            // 粘贴版，处理粘贴时候带图片
            matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]],
          },
          toolbar: {
            container: [],
          },
        },
      },
    };
  },

  watch: {
    value(val) {
      this.content = val;
    },
    content(val) {
      this.$emit("input", val);
    },
  },
  created() {},
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
    quill() {
      // 获取富文本组件实例
      return this.$refs[this.myRef].quill;
    },
  },
  mounted() {
    bus.$on(this.myRef + "addStyle", this.handleSetContent);
    this.initHeight()
  },
  methods: {
    onEditorBlur() {
      //失去焦点事件
    },
    handleCustomMatcher(node, Delta) {
      let ops = [];
      Delta.ops.forEach((op) => {
        if (op.insert) {
          if (typeof op.insert === "string") {
            // 如果粘贴了图片，这里会是一个对象，所以可以这样处理
            ops.push(op);
          } else {
            let o = true;
            if (op.insert.constructor === Object) {
              for (const opKey in op.insert) {
                if (
                  op.insert[opKey].includes(";base64,") &&
                  op.insert[opKey].includes("data:image/")
                ) {
                  o = false;
                  this.$message({
                    message: "不允许粘贴图片,请手动上传",
                    type: "warning",
                  });
                }
              }
            }
            if (o) ops.push(op);
          }
        }
      });
      Delta.ops = ops;
      return Delta;
    },
    onEditorFocus() {
      //通过焦点事件，获取选中的样式
      bus.$emit(this.myRef, this.quill.getFormat());
    },
    handleSetContent(type, val) {
      this.quill.focus();
      if (type === "image") {
        let a = "." + this.myRef + "upload" + " input";
        // 触发inpu选择图片t框文件
        document.querySelector(a).click();
      } else if (type === "clean") {
        // 清清除样式
        var range = this.quill.getSelection();
        this.quill.removeFormat(range, "user");
      } else {
        this.quill.format(type, val);
      }
    },
    uploadSuccess(res) {
      // 如果上传成功
      if (res.code == 0) {
        // 获取光标所在位置
        let length = this.quill.getSelection().index;
        this.quill.insertEmbed(length, "image", res.data.imagePath);
        // 调整光标到最后
        this.quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
    },
    // 富文本图片上传失败
    uploadError() {
      this.$message.error("图片插入失败");
    },
    // 设置 编辑区域的高度
    initHeight() {
      let qlEditor = this.$refs[this.myRef]

      // 如果设置了最小高度，或者最大高度。将覆盖高度height
      if (this.maxHeight || this.minHeight) {
        if (this.maxHeight) {
          this.maxHeight.includes("px") || this.maxHeight.includes("%")
                  ? (qlEditor.$el.style.maxHeight = this.maxHeight)
                  : (qlEditor.$el.style.maxHeight = this.maxHeight + "px");
        }

        if (this.minHeight) {
          this.minHeight.includes("px") || this.minHeight.includes("%")
                  ? (qlEditor.$el.style.minHeight = this.minHeight)
                  : (qlEditor.$el.style.minHeight = this.minHeight + "px");
        }
      } else if (this.height) {
        this.height.includes("px") || this.height.includes("%")
                ? (qlEditor.$el.style.height = this.height)
                : (qlEditor.$el.style.height = this.height + "px");
        qlEditor.$el.style.maxHeight = 'none'
      }
    },
  },
};
</script>
<style>
@import "index.css";
.restructureEditor .ql-toolbar {
  display: none;
}
.jyxClass p,
.jyxClass h1,
.jyxClass h4,
.jyxClass h3,
.jyxClass h2{
  text-indent: 32px;
  white-space: initial;
}
.jyxClass p{
  font-size: 16px;
}
.jyxClass img{
  max-width: calc(100% - 33px);
}
</style>



// WEBPACK FOOTER //
// src/components/zl-editor/index.vue